import { InitialIntegrationReducer } from "../../../../_services/store/InitialIntegrationReducer";
import { createSlice } from "@reduxjs/toolkit";
import { INITIAL_NEW_CONFIGURATION, integrationReducerActions } from "../../../../_commons/integration.reducer";

export const initialAboutYouPaymentsReducer = {
    ...new InitialIntegrationReducer(),
    newConfiguration: {
        ...INITIAL_NEW_CONFIGURATION,
    },
};

const aboutYouPaymentsSlice = createSlice({
    name: "AboutYouPayments",
    initialState: { ...initialAboutYouPaymentsReducer },
    reducers: {
        ...integrationReducerActions,
    },
});

export default aboutYouPaymentsSlice;
